import {
  TrendingUp,
  PieChart,
  LineChart,
  Building,
  FileText,
  Briefcase,
} from "lucide-react";
import Reveal from "@/components/Reveal";

const CORPORATE = [
  {
    icon: TrendingUp,
    title: "Investment & Asset Management",
    desc: "Curated portfolios, advisory and multi-asset allocation for HNI and corporate clients.",
  },
  {
    icon: PieChart,
    title: "Mutual Funds & SIP",
    desc: "Goal-based mutual-fund selection, SIP planning and quarterly portfolio reviews.",
  },
  {
    icon: LineChart,
    title: "Shares, Debentures & G-Sec",
    desc: "Equity, debenture and government-securities investment solutions for steady growth.",
  },
  {
    icon: Briefcase,
    title: "Project Funding & Working Capital",
    desc: "Corporate loans, project financing and working-capital support for growing businesses.",
  },
  {
    icon: FileText,
    title: "ITR · ROC · Accounting",
    desc: "Full-stack compliance — income-tax filing, ROC returns, books of accounts & GST.",
  },
  {
    icon: Building,
    title: "Company Formation & Joint Ventures",
    desc: "Pvt. Ltd. · LLP · OPC incorporations, business expansion and JV structuring.",
  },
];

export default function CorporateServices() {
  return (
    <section
      id="corporate"
      data-testid="corporate-services"
      className="relative bg-[#FAF6EC] text-[#0C1530] py-24 md:py-32 overflow-hidden"
    >
      <div className="pointer-events-none absolute -top-24 left-1/3 w-[500px] h-[500px] rounded-full bg-[#D4AF37]/8 blur-3xl" />

      <div className="relative max-w-7xl mx-auto px-6 md:px-12">
        <Reveal>
          <div className="text-center">
            <span className="gold-divider text-[11px] tracking-[0.32em] uppercase text-[#B68F1E]">
              Beyond loans
            </span>
            <h2
              data-testid="corporate-heading"
              className="font-display text-[40px] md:text-[60px] mt-5 leading-[1.05] tracking-tight"
            >
              Corporate &amp; <em className="not-italic text-[#B68F1E]">wealth services</em>
            </h2>
            <p className="mt-4 text-[#0C1530]/70 max-w-2xl mx-auto">
              Through{" "}
              <span className="font-semibold">Noble Infinity Asset Management Pvt Ltd</span>, we
              also offer investment, advisory and compliance services to power your business
              ambitions.
            </p>
          </div>
        </Reveal>

        <div className="mt-14 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {CORPORATE.map(({ icon: Icon, title, desc }, i) => (
            <Reveal key={title} delay={i * 70}>
              <div
                data-testid={`corporate-card-${title.toLowerCase().replace(/\s+/g, "-").replace(/[^a-z0-9-]/g, "")}`}
                className="group h-full bg-[#0A1F44] text-white rounded-2xl p-7 border border-[#D4AF37]/25 hover:border-[#D4AF37]/70 hover:-translate-y-1 transition-all duration-300 relative overflow-hidden"
              >
                <div className="absolute -top-16 -right-16 w-48 h-48 rounded-full bg-[#D4AF37]/10 blur-2xl opacity-0 group-hover:opacity-100 transition-opacity" />
                <div className="tile-icon">
                  <Icon size={26} strokeWidth={1.75} />
                </div>
                <h3 className="mt-5 font-display text-xl md:text-2xl">{title}</h3>
                <p className="mt-2 text-white/65 text-sm leading-relaxed">{desc}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
